import { GamingPerformancePrompt } from './GamingPerformancePrompt';

export default GamingPerformancePrompt;
